<template>
    <div class="grid xl:grid-cols-2 2xl:grid-cols-3 gap-8">
        <div
            v-for="subscriptionProduct in getNonSeatSubscriptionProducts()"
            :key="subscriptionProduct"
            class="rounded border"
        >
            <div class="pl-3 pr-3 pt-3 text-sm font-bold">
                {{
                    getFromDictionary(
                        `products.${subscriptionProduct.product.productType}`,
                        'label',
                    ).toLocaleUpperCase()
                }}
                {{ subscriptionProduct.quantity > 1 ? `(${subscriptionProduct.quantity})` : '' }}
            </div>

            <div class="p-3">
                <div class="pb-3 text-sm">
                    {{ getFromDictionary(`products.${subscriptionProduct.product.productType}`, 'description') }}
                </div>
                <div v-if="subscriptionProduct.price">
                    <span class="font-bold">{{
                        $filters.formatCurrency(subscriptionProduct.price?.amount * subscriptionProduct.quantity)
                    }}</span>/{{ getPriceIntervalName(subscriptionProduct.price) }}
                </div>
            </div>

            <div class="border-b mx-3"></div>

            <!-- <div class="border-b p-3">
                <div
                    v-if="
                        subscriptionProduct?.price?.relatedPriceId &&
                        subscriptionProduct.subscription.status !== 'ending' &&
                        !hasScheduledChanges
                    "
                    class="pb-3"
                >
                    Additional seat(s)
                    <div class="flex pt-3">
                        <input
                            :id="subscriptionProduct.price.relatedPriceId"
                            v-model="subscriptionProductCounts[subscriptionProduct.price.relatedPriceId]"
                            class="flex h-8 w-24 rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50"
                            type="number"
                            @input="
                                onRelatedChange(subscriptionProduct.price.id, subscriptionProduct.price.relatedPriceId)
                            "
                        />
                        <div class="ml-3 mt-1">
                            <span class="font-bold">
                                {{
                                    $filters.formatCurrency(
                                        calculateMonthlyPrice(
                                            getSeatPrice(subscriptionProduct.price.relatedPriceId),
                                            subscriptionProductCounts[subscriptionProduct.price.relatedPriceId],
                                        ),
                                    )
                                }}</span
                            >/month
                        </div>
                    </div>
                </div>
            </div> -->

            <div>
                <div v-if="subscriptionProduct.subscription.status === 'ending'">
                    <div
                        v-if="subscriptionProduct?.price?.selfManaged"
                        class="flex justify-center p-4"
                    >
                        <Button size="lg" class="w-full xl:max-w-xs font-semibold" @click="onManageSubscription(subscriptionProduct)">Manage</Button>
                    </div>
                    <div
                        v-else
                        class="flex justify-center p-4"
                    >
                        <Button variant="outline" size="lg" class="w-full xl:max-w-xs font-semibold" @click="onContactUs(subscriptionProduct)">Contact us</Button>
                    </div>
                    <div class="px-4 mb-2 text-sm font-semibold italic">
                        (Canceled, expires {{ $filters.formatDate(subscriptionProduct.subscription.expiresAt) }})
                    </div>

                    <div class="border-b mx-3"></div>
                </div>



                <div v-else-if="subscriptionProduct?.price?.selfManaged && !hasScheduledChanges">
                    <div class="flex justify-center p-4">
                        <Button size="lg" class="w-full xl:max-w-xs font-semibold" @click="onManageSubscription(subscriptionProduct)">Manage</Button>
                    </div>
                    <div
                        v-if="subscriptionProductChanged[subscriptionProduct?.price?.id] === true"
                        class="flex justify-center px-4 mb-4"
                    >
                        <Button
                            variant="outline"
                            size="lg"
                            class="w-full xl:max-w-xs font-semibold"
                            @click="
                                onChangeSubscriptionCounts(
                                    subscriptionProduct,
                                    subscriptionProduct.price.relatedPriceId,
                                    subscriptionProductCounts[subscriptionProduct.price.relatedPriceId],
                                )
                            "
                        >
                            Update seats
                        </Button>
                    </div>

                    <div class="border-b mx-3"></div>
                </div>
                <div v-else-if="subscriptionProduct?.price?.selfManaged || hasScheduledChanges">
                    <div
                        class="flex justify-center p-4"
                    >
                        <Button variant="outline" size="lg" class="w-full xl:max-w-xs font-semibold" @click="onContactUs(subscriptionProduct)">Contact us</Button>
                    </div>

                    <div class="border-b mx-3"></div>
                </div>
            </div>

            <div class="pl-3 pr-3 pt-3">
                <div class="pb-3 text-xs font-bold">WHAT'S INCLUDED</div>
                <div class="pb-4">
                    <ul class="space-y-2.5">
                        <li
                            v-for="includedItem in getIncludedItems(subscriptionProduct)"
                            :key="includedItem"
                            class="flex text-sm leading-none"
                        >
                            <AppIcon name="check" class="my-auto h-3 w-3 text-emerald-500" />
                            <span class="pl-2">
                                {{ includedItem }}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <Card variant="cta">
            <div class="px-4 pt-4 text-sm font-bold flex items-center text-white">
                <AppIcon name="sparkles" class="mr-2 h-4 w-4" />
                NEED MORE?
            </div>
            <div class="p-4">
                <div class="pb-3 text-sm text-indigo-100">
                    Book a 15 minute chat with our team to get your free campaign-ready creator shortlist.
                </div>
            </div>
            <div class="border-b mx-4 border-white/20"></div>
            <div class="px-4 pt-4">
                <div class="pb-4">
                    <ul class="space-y-2.5">
                        <li class="flex text-sm leading-none">
                             <AppIcon name="check" class="my-auto h-3 w-3 text-white" />
                             <span class="pl-2">Tell us about your influencer marketing goals</span>
                        </li>
                        <li class="flex text-sm leading-none">
                             <AppIcon name="check" class="my-auto h-3 w-3 text-white" />
                             <span class="pl-2">Discuss your target audience & data needs</span>
                        </li>
                        <li class="flex text-sm leading-none">
                             <AppIcon name="check" class="my-auto h-3 w-3 text-white" />
                             <span class="pl-2">Explore upgrade options</span>
                        </li>
                        <li class="flex text-sm leading-none">
                             <AppIcon name="check" class="my-auto h-3 w-3 text-white" />
                             <span class="pl-2">Get your custom list of campaign-ready creators</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="flex justify-center p-4">
                <Button
                    size="lg"
                    class="w-full xl:max-w-xs font-bold bg-white text-indigo-600 hover:bg-indigo-50 shadow-md transition-all hover:scale-105"
                    @click="onUpgradeNow()"
                >
                    Upgrade now
                </Button>
            </div>
        </Card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'

export default {
    name: 'SubscriptionsTable',
    components: {
        Button,
        Card,
    },
    props: {
        subscriptions: {
            type: Object,
        },
        isSubscriptionsLoading: {
            type: Boolean,
        },
        productPrices: {
            type: Object,
        },
        hasScheduledChanges: {
            type: Boolean,
        },
    },

    emits: ['manage-subscription', 'change-subscription'],

    data() {
        return {
            subscriptionProductCounts: {},
            subscriptionProductCountsInitial: {},
            subscriptionProductChanged: {},
        }
    },

    computed: {
        ...mapGetters(['getFromDictionary']),
        subscriptionProducts() {
            const subProducts = []
            _.forEach(this.subscriptions, (subscription) => {
                _.forEach(subscription.products, (product) => {
                    subProducts.push({
                        subscription,
                        product: product.product,
                        price: product.price,
                        quantity: product.quantity,
                    })
                })
            })

            _.orderBy(subProducts, ['price.amount'], ['asc'])

            const nonSeatProducts = _.filter(subProducts, (subscriptionProduct) => {
                return subscriptionProduct.product.productType !== 'seat'
            })
            const seatProducts = _.filter(subProducts, (subscriptionProduct) => {
                return subscriptionProduct.product.productType === 'seat'
            })

            return nonSeatProducts.concat(seatProducts) // Seats last
        },
    },

    watch: {
        productPrices() {
            this.resetProductCounts()
        },
        subscriptions() {
            this.resetProductCounts()
        },
    },

    created() {
        this.resetProductCounts()
    },

    methods: {
        resetProductCounts() {
            this.subscriptionProductCounts = {}
            this.subscriptionProductCountsInitial = {}

            _.forEach(this.productPrices, (productPrice) => {
                this.subscriptionProductCounts[productPrice.price.id] = 0
                this.subscriptionProductCountsInitial[productPrice.price.id] = 0
            })

            _.forEach(this.subscriptionProducts, (subscriptionProduct) => {
                if (subscriptionProduct.price) {
                    this.subscriptionProductCounts[subscriptionProduct.price.id] = subscriptionProduct.quantity
                    this.subscriptionProductCountsInitial[subscriptionProduct.price.id] = subscriptionProduct.quantity
                }
            })
        },
        getNonSeatSubscriptionProducts() {
            return _.filter(this.subscriptionProducts, (subscriptionProduct) => {
                return subscriptionProduct.product.productType !== 'seat'
            })
        },
        getIncludedItems(subscriptionProduct) {
            let includedItems = this.getFromDictionary(
                `products.${subscriptionProduct.product.productType}`,
                'included',
            )

            includedItems = [...includedItems]

            if (
                subscriptionProduct?.price?.relatedPriceId &&
                this.subscriptionProductCountsInitial[subscriptionProduct.price.relatedPriceId] > 0
            ) {
                const seatQuantity = this.subscriptionProductCountsInitial[subscriptionProduct.price.relatedPriceId]
                if (seatQuantity === 1) {
                    includedItems.unshift('1 additional seat')
                } else {
                    includedItems.unshift(`${seatQuantity} additional seats`)
                }
            }

            const defaultSeats = this.getFromDictionary(
                `products.${subscriptionProduct.product.productType}`,
                'defaultSeats',
            )

            if (defaultSeats > 1) {
                includedItems.unshift(`${defaultSeats} included seats`)
            } else {
                includedItems.unshift('1 included seat')
            }

            return includedItems
        },
        onManageSubscription(subscription) {
            this.$emit('manage-subscription', subscription)
        },
        onChangeSubscriptionCounts(subscription, relatedPriceId, relatedPriceCount) {
            this.$emit('change-subscription', subscription, relatedPriceId, relatedPriceCount)
        },
        getPriceIntervalName(productPrice) {
             if (productPrice.billingInterval === 'year') {
                return 'year'
            }
            return 'mo'
        },

        getSeatPrice(id) {
            const seatProductInSubscription = _.find(this.subscriptionProducts, (subscriptionProduct) => {
                return subscriptionProduct?.price?.id === id
            })

            if (seatProductInSubscription) {
                return seatProductInSubscription.price
            }

            const seatPrice = _.find(this.productPrices, (productPrice) => {
                return productPrice.price.id === id
            })

            if (seatPrice) {
                return seatPrice.price
            }

            return null
        },

        onRelatedChange(priceId, relatedPriceId) {
            if (this.subscriptionProductCounts[relatedPriceId] < 0) {
                this.subscriptionProductCounts[relatedPriceId] = 0
            } else if (this.subscriptionProductCounts[relatedPriceId] > 999) {
                this.subscriptionProductCounts[relatedPriceId] = 999
            }

            if (
                this.subscriptionProductCounts[relatedPriceId] !== this.subscriptionProductCountsInitial[relatedPriceId]
            ) {
                this.subscriptionProductChanged[priceId] = true
            } else {
                this.subscriptionProductChanged[priceId] = false
            }
        },
        onContactUs() {
            this.intercomModule.show()
        },
        onUpgradeNow() {
            window.open(
                'https://calendly.com/d/cqzs-9m2-9hn/build-your-custom-plan',
                '_blank',
                'noopener,noreferrer'
            )
        },
    },
}
</script>

<style scoped>
</style>
